import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './views/home'
import Contact from './views/contact'
import Login from './views/login'
import DashboardLayout from './components/DashboardLayout'
import BlockManagement from './views/BlockManagement'
import Settings from './views/settings'
import NotFound from './views/not-found'
import Partners from './views/Partners'
import ProductPage from './views/ProductPage'
import SunscreenFacts from './views/SunscreenFacts'
import AboutUs from './views/AboutUs'
import Careers from './views/Careers'
import ScrollToTop from './components/ScrollToTop'
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/sunscreen-facts" element={<SunscreenFacts />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route path="block-management" element={<BlockManagement />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;